export type MotiFileType =
  "application/msword" |
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document" |
  "image/gif" |
  "image/jpeg" |
  "application/pdf" |
  "image/png" |
  "image/tiff" |
  "image/webp";

export type FileExt = "doc" | "docx" | "gif" | "jpg" | "pdf" | "png" | "tif" | "webp";

export function getFileExtension(mimeType: MotiFileType): FileExt {
  const mimeToExtension: { [key in MotiFileType]: FileExt } = {
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "image/gif": "gif",
    "image/jpeg": "jpg",
    "application/pdf": "pdf",
    "image/png": "png",
    "image/tiff": "tif",
    "image/webp": "webp",
  };

  return mimeToExtension[mimeType];
}
